// FIRST, and deliberately so: this starts Sentry, and an import is evaluated before the imports
// below it, so the crash reporter is running before the rest of the app's modules load. Moving it
// down, or turning it into a call in the body, would start Sentry after the whole graph has
// already evaluated. See app-sentry-init.ts.
import './app-sentry-init';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module'; // ??!!?? this import must be relative, otherwise webpack trims the entire app in 'prod' mode!
import { enableProdMode } from '@angular/core';
import { AppEnvironment } from 'environments/environment';
import { initDeepLinks } from './app-page-list';
import { handleBootstrapFailureAsync } from './bootstrap-failure';

if (AppEnvironment.isAngularProduction) {
  enableProdMode();
}
initDeepLinks();
void platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    // O2 (#4027 Step 23): a bootstrap rejection used to be console-only — a
    // forever-splash with zero telemetry. Now: static error UI + the Step-22
    // boot marker (reports on the next boot) + one raw Sentry beacon.
    console.error(err);
    void handleBootstrapFailureAsync(err);
  });
